import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
interface HamburgerMenuProps {
  isOpen: boolean;
  onClose: () => void;
}
export function HamburgerMenu({
  isOpen,
  onClose
}: HamburgerMenuProps) {
  const [shouldRender, setShouldRender] = useState(isOpen);
  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      document.body.style.overflow = 'hidden';
    } else {
      const timer = setTimeout(() => setShouldRender(false), 400); // Match animation duration
      document.body.style.overflow = '';
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  if (!shouldRender) return null;
  return <div className="fixed inset-0 z-[60] flex justify-end" data-id="element-89">
      {/* Backdrop */}
      <div className={`absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-400 ${isOpen ? 'animate-fade-in' : 'animate-fade-out'}`} onClick={onClose} data-id="element-90" />

      {/* Menu Panel */}
      <div className={`relative h-full bg-white w-full md:w-[400px] lg:w-[500px] shadow-2xl flex flex-col ${isOpen ? 'animate-slide-in-right' : 'animate-slide-out-right'}`} data-id="element-91">
        {/* Close Button */}
        <button onClick={onClose} className="absolute top-6 right-8 p-2 text-charcoal hover:text-gold transition-colors z-10" aria-label="Close menu" data-id="element-92">
          <X size={32} data-id="element-93" />
        </button>

        <div className="flex flex-col h-full p-8 md:p-12 overflow-y-auto" data-id="element-94">
          {/* Mobile Layout: Stacked / Desktop Layout: 2 Columns */}
          <div className="flex flex-col lg:flex-row h-full gap-12 mt-12" data-id="element-95">
            {/* Navigation Links */}
            <nav className="flex flex-col gap-8" data-id="element-96">
              {['WINES', 'ABOUT', 'SUSTAINABILITY', 'CONTACT'].map(item => <a key={item} href={`#${item.toLowerCase()}`} onClick={onClose} className="font-optima font-semibold text-[32px] text-charcoal hover:text-gold transition-colors cursor-pointer" data-id="element-97">
                  {item}
                </a>)}
            </nav>

            {/* Wine Range Cards (Visual) */}
            <div className="flex flex-col gap-6 lg:w-[60%]" data-id="element-98">
              {[{
              name: 'BLOCK Range',
              img: 'https://images.unsplash.com/photo-1547595628-c61a29f496f0?w=400&q=80'
            }, {
              name: 'ESTATE Range',
              img: 'https://images.unsplash.com/photo-1566754436773-6e083aba1fc0?w=400&q=80'
            }, {
              name: 'GO Range',
              img: 'https://images.unsplash.com/photo-1560148218-1a83060f7b32?w=400&q=80'
            }].map((wine, index) => <div key={wine.name} className={`group relative rounded-lg overflow-hidden shadow-md h-[120px] cursor-pointer ${isOpen ? 'animate-fade-in-up' : ''}`} style={{
              animationDelay: `${(index + 1) * 100}ms`
            }} data-id="element-99">
                  <img src={wine.img} alt={wine.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-100" />
                  <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors" data-id="element-101" />
                  <div className="absolute bottom-4 left-4 text-white font-optima font-semibold text-lg tracking-wide" data-id="element-102">
                    {wine.name}
                  </div>
                </div>)}
            </div>
          </div>

          {/* Bottom CTA */}
          <div className="mt-auto pt-8" data-id="element-103">
            <button className="w-full bg-charcoal text-white px-8 py-4 rounded-lg hover:border-gold border-2 border-transparent transition-all font-optima font-semibold uppercase tracking-wide-btn text-sm" data-id="element-104">
              Join the Wine Club
            </button>
          </div>
        </div>
      </div>
    </div>;
}